<script>
import ParticipantsIframeTable from "./IframeTable";

export default {
    components: {
        ParticipantsIframeTable,
    },
    props: {
        initial: {
            type: String,
            required: false
        }
    },
    data() {
        return {
            registration_category: [],
            rows: 0, //The count of rows
            query: '', //The free string query i.e. name
            queryString: '', //The calculated query string
        }
    },
    methods: {
        buildQuery(field) {

            let searchParams = new URLSearchParams(window.location.search)
            searchParams = this.deleteQueryParam(searchParams, field);
            let currentQuery = window.location.pathname + '?' + searchParams.toString();

            if (Array.isArray(this[field])) {
                this[field].forEach((status, index) => {
                    currentQuery += `&${field}[${index}]=${status}`
                })
            } else {
                currentQuery += `&${field}=${this.query}`
            }

            history.replaceState({}, null, currentQuery);
            searchParams = new URLSearchParams(window.location.search)
            this.queryString = searchParams.toString();
        },
        deleteQueryParam(searchParams, key) {
            searchParams.delete(key);

            if(Array.isArray(this[key])){
                for (let i = 0; i <= 200; i++) { //20 - currently on admin/participant/occasions/XXX we add registration_category[0]=1231&registration_category[1]=XX.....
                    let queryKey = key + '[' + i + ']';
                    searchParams.delete(queryKey);
                }
            }

            return searchParams;
        },
        parseQuery(queryString) {
            var params = {}, queries, temp, i, l;

            // Split into key/value pairs
            queries = queryString.split("&");

            // Convert the array of strings into an object
            for (i = 0, l = queries.length; i < l; i++) {
                temp = queries[i].split('=');
                params[temp[0]] = temp[1];
            }

            return params;
        },
        setDataFromQuery() { //Used when the page is first loaded to set the inital query from the URL query string
            let urlComponents = (this.parseQuery(decodeURIComponent(this.initial)));
            Object.keys(urlComponents).map((key, item) => {
                let value = urlComponents[key];
                if (key.includes('registration_category')) {
                    this.registration_category.push(value);
                }
            });
        },
        updated(payload) { //When the table is updated after the search filter changes
            this.rows = payload.rows;
        },
    },
    watch: {
        registration_category() {
            this.buildQuery('registration_category');
        },
        query() {
            this.buildQuery('q');
        },
    },

    mounted() {
        this.setDataFromQuery();
    },
}
</script>




// WEBPACK FOOTER //
// src/Assets/components/Participants/IframeTableContainer.vue